import React from "react";
import "../../styles/footer.css";
import { BsFacebook } from "react-icons/bs";
import { AiTwotoneMail } from "react-icons/ai";
import { CiYoutube } from "react-icons/ci";
import { BiLogoInstagram } from "react-icons/bi";
import whatsapp from "../../assets/whatsapp.png";
import logo from "../../assets/mathilogo.png"; // Ensure this matches your file name

const Footer = () => {
  return (
    <footer className="footer-section">
      <div className="container">
        {/* ADDED 'align-items-start' to force top alignment */}
        <div className="footer-content row align-items-start">
          
          {/* COLUMN 1: LOGO */}
          <div className="col-lg-4 col-md-6 footer-col">
            <div className="footer-logo">
              <img
                src={logo}
                alt="Madhi Academy Logo"
                className="img-fluid" /* Ensures responsive sizing */
              />
            </div>
          </div>

          {/* COLUMN 2: COMPANY LINKS */}
          <div className="col-lg-2 col-md-3 col-sm-6 footer-col">
            <h4 className="footer-heading">Company</h4>
            <ul className="footer-links">
              <li><a href="https://madhiacademy.com">Home</a></li>
              <li><a href="/about">About Us</a></li>
              <li><a href="/faq">FAQ</a></li>
              <li><a href="/contact">Contact Us</a></li>
            </ul>
          </div>

          {/* COLUMN 3: COURSE LINKS */}
          <div className="col-lg-3 col-md-3 col-sm-6 footer-col">
            <h4 className="footer-heading">Our Course</h4>
            <ul className="footer-links">
              <li>
                <a href="https://tuition.madhiacademy.com" target="_blank" rel="noopener noreferrer">
                  Tuition Programs
                </a>
              </li>
              <li>
                <a href="https://pro.madhiacademy.com" target="_blank" rel="noopener noreferrer">
                  Indian Professional Courses
                </a>
              </li>
              <li>
                <a href="https://global.madhiacademy.com" target="_blank" rel="noopener noreferrer">
                  Global Professional Courses
                </a>
              </li>
              <li>
                <a href="https://degree.madhiacademy.com" target="_blank" rel="noopener noreferrer">
                  Commerce Degrees
                </a>
              </li>
              <li>
                <a href="https://skills.madhiacademy.com" target="_blank" rel="noopener noreferrer">
                  Skills Training
                </a>
              </li>
            </ul>
          </div>

          {/* COLUMN 4: CONNECT WITH US */}
          <div className="col-lg-3 col-md-12 footer-col">
            <h4 className="footer-heading">Connect with us</h4>
            <div className="social-icons">
              <a href="mailto:info@madhiacademy.com" className="social-circle" aria-label="Email Us">
                <i className="fas fa-envelope"><AiTwotoneMail /></i>
              </a>
              <a href="https://www.facebook.com" target="_blank" rel="noopener noreferrer" className="social-circle" aria-label="Facebook">
                <i className="fab fa-facebook-f"><BsFacebook /></i>
              </a>
              <a href="https://www.youtube.com" target="_blank" rel="noopener noreferrer" className="social-circle" aria-label="YouTube">
                <i className="fab fa-youtube"><CiYoutube /></i>
              </a>
              <a href="https://www.instagram.com" target="_blank" rel="noopener noreferrer" className="social-circle" aria-label="Instagram">
                <i className="fab fa-instagram"><BiLogoInstagram /></i>
              </a>
            </div>
          </div>
        </div>

        {/* BOTTOM DIVIDER & COPYRIGHT */}
        <div className="footer-bottom">
          <div className="divider"></div>
          <div className="row align-items-center">
            <div className="col-md-6 text-md-start text-center">
              <p className="copyright-text">
                Copyright Madhi Academy © 2025. All Rights Reserved
              </p>
            </div>
            <div className="col-md-6 text-md-end text-center">
              <p className="credits-text">An Ascent Brandworks Creation</p>
            </div>
          </div>
        </div>
      </div>

      {/* FLOATING WHATSAPP ICON */}
      <a
        href="https://wa.me/7708941960"
        className="whatsapp-float"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chat on WhatsApp"
      >
        <img src={whatsapp} style={{ width: "60px" }} alt="WhatsApp Chat" />
      </a>
    </footer>
  );
};

export default Footer;